<template>
  <div>
    <header-top />
    <div class="system-setting">
      <div class="setting-menu">
        <!-- {{permissions}} -->
        <el-collapse v-model="activeNames">
          <el-collapse-item
            :title="item.name"
            :name="item.name"
            v-for="(item, index) in settingList"
            :key="index"
            :class="{
              'no-child': !item.children,
              'color-item': !item.children && parentName == item.name,
            }"
            v-show="
              (permissions['System.CustomerSettings'] &&
                item.name == '客源设置') ||
              (permissions['System.EstateSettings'] && item.name == '楼盘设置')||
              (permissions['System.UserSettings'] && item.name == '人事设置')||
              (permissions['System.IdentitySettings'] && item.name == '账户设置')||
              (permissions['System.TenantSettings'] && item.name == '租户设置')||
              (permissions['System.SmsSettings'] && item.name == '短信设置')||
              (permissions['System.WeixinSettings'] && item.name == '微信设置')||
              (permissions['System.AreaSettings'] && item.name == '地区设置')||
              (permissions['System.AdvertSettings'] && item.name == '广告设置')||
              (permissions['System.InformationSettings'] && item.name == '资讯设置')||
              (permissions['System.TransactionSettings'] && item.name == '交易设置')
              
            "
            @click.native="selectParent(item)"
          >
          
          <!-- permissions['System.SmsSettings'] &&  -->
            <div
              class="collapse-item"
              @click="selectItem(item.name, child.name)"
              v-for="(child, i) in item.children"
              :key="i"
              :class="{ 'color-item': child.name == childName }"
            >
              {{ child.name }}
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="setting-main">
        <div class="main-header" v-if="childName != '参数配置'&&childName != '业绩管理'&&childName != '资金管理'">
          {{ settingTitle }}
        </div>
        <div class="setting-content">
          <fields-basic v-if="childName == '人事基本设置'" />
          <fields-parameter v-if="childName == '人事参数配置'" />
          <!-- <channel v-if="parentName == '分销商设置'" /> -->
          <customer-parameter
            ref="customerBasic"
            v-if="childName == '客源基本设置'"
            :isEdit="isEdit"
          />
          <customer-basic
            v-if="childName == '客源参数配置'"
            :isEdit="isEdit"
          />
          
          <realEstate-parameter
            v-if="childName == '楼盘基本设置'"
            :isEdit="isEdit"
          />
          <realEstate-basic
            ref="realEstateBasic"
            v-if="childName == '楼盘参数配置'"
            :isEdit="isEdit"
          />
          <transaction-system v-if="childName == '参数配置'" :isEdit="isEdit"></transaction-system>
          <collect-receipt-system v-if="childName == '资金管理'" :isEdit="isEdit"></collect-receipt-system>
          <platform-feeRate-system v-if="childName == '业绩管理'" :isEdit="isEdit"></platform-feeRate-system>
          <tenant-parameter v-if="childName == '租户基本设置'" :isEdit="isEdit"></tenant-parameter>
          <tenant-basic v-if="childName == '租户参数配置'" :isEdit="isEdit"></tenant-basic>
          <identity v-if="parentName == '账户设置'" :isEdit="isEdit"></identity>
          <sms-system v-if="parentName == '短信设置'" :isEdit="isEdit"></sms-system>
          <wechart-system v-if="parentName == '微信设置'" :isEdit="isEdit"></wechart-system>
          <area-system v-if="parentName == '地区设置'" :isEdit="isEdit"></area-system>
          <ads-system v-if="parentName == '广告设置'" :isEdit="isEdit"></ads-system>
          <news-system v-if="parentName == '资讯设置'" :isEdit="isEdit"></news-system>
          <transaction-system v-if="childName == '参数配置'" :isEdit="isEdit"></transaction-system>
          <collect-receipt-system v-if="childName == '资金管理'" @childName="getChildName" :isEdit="isEdit"></collect-receipt-system>
          <platformFeeRate-system v-if="childName == '业绩管理'" :isEdit="isEdit"></platformFeeRate-system>
        </div>
      </div>
    </div>
    <div class="bottom-btns" v-if="isEdit">
      <div>
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { deepCopy } from "@/utils/deepCopy";
import headerTop from "@/components/HeaderTop";
import fieldsBasic from "./fields-basic";
import fieldsParameter from "./fields-parameter";
// import channel from "./channel";
import customerParameter from "./customer-parameter";
import customerBasic from "./customer-basic";
import realEstateParameter from "./real-estate-parameter";
import realEstateBasic from "./real-estate-basic";
import identity from "./identity";
import smsSystem from "./smsSystem";
import wechartSystem from "./wechartSystem";
import areaSystem from "./areaSystem";
import adsSystem from "./adsSystem";
import newsSystem from "./news-system";
import transactionSystem from "./transactionSystem";
import collectReceiptSystem from "./collect-receipt-system";
import platformFeeRateSystem from "./platform-fee-rate-system";
import tenantBasic from "./tenantBasic";
import tenantParameter from "./tenantParameter";
export default {
  data() {
    return {
      activeNames: [],
      permissions: this.$store.getters.permissions,
      parentName: "",
      childName: "",
      settingList: [
        {
          name: "人事设置",
          children: [{ name: "人事基本设置" }, { name: "人事参数配置" }],
        },
        {
          name: "客源设置",
          children: [{ name: "客源基本设置" }, { name: "客源参数配置" }],
        },
        {
          name: "楼盘设置",
          children: [{ name: "楼盘基本设置" }, { name: "楼盘参数配置" }],
        },
        // {
        //   name: "分销商设置",
        // },
        {
          name: "租户设置",
           children: [{ name: "租户基本设置" }, { name: "租户参数配置" }],
        },
        {
          name: "账户设置",
        },
        {
          name: "短信设置",
        },
        {
          name: "微信设置",
        },
        {
          name: "地区设置",
        },
        {
          name: "广告设置",
        },
        {
          name: "资讯设置",
        },
        // {
        //   name: "交易设置",
        //   children: [{ name: "参数配置" }, { name: "资金管理" }, { name: "业绩管理" }],
        // },
      ],
      isEditShow: false,
      isEdit: false,
      headerText: "",
    };
  },
  components: {
    headerTop,
    fieldsParameter,
    fieldsBasic,
    tenantBasic,
    tenantParameter,
    // channel,
    customerParameter,
    customerBasic,
    realEstateParameter,
    realEstateBasic,
    identity,
    smsSystem,
    wechartSystem,
    areaSystem,
    transactionSystem,
    collectReceiptSystem,
    adsSystem,
    newsSystem,
    platformFeeRateSystem,
  },
  computed: {
    settingTitle() {
      if (this.childName) {
        return this.parentName + " / " + this.childName;
      } else {
        return this.parentName;
      }
    },
  },
  methods: {
    cancel() {
      this.isEdit = false;
      this.$refs.customerBasic.cancel();
    },
    submit() {
      this.isEdit = false;
      this.$refs.customerBasic.submit();
    },
    getChildName(val){//console.log(val,99);
      this.selectItem('交易设置', val)
    },
    selectItem(p, c) {
      this.parentName = p;
      this.childName = c;
      //console.log(this.childName, "childName");
      if (c == "客源基本设置") {
        this.isEditShow = true;
      } else {
        this.isEditShow = false;
      }
    },
    selectParent(v) {
      //console.log(v, 666);
      if (!v.children) {
        this.parentName = v.name;
        this.childName = "";
        this.isEditShow = false;
      }
      //console.log(this.parentName, "parentName");
    },
    init() {
      this.parentName = this.settingList[0].name;
      if (this.settingList[0].children) {
        this.childName = this.settingList[0].children[0].name;
      }
      this.activeNames = [this.parentName];
    },
    edit() {
      this.isEdit = true;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.system-setting {
  display: flex;
  padding: 20px;

  .setting-menu {
    box-sizing: border-box;
    border-radius: $--border-radius-base;
    padding: 16px 0;

    width: 220px;
    min-height: calc(100vh - 148px);
    background: #fff;
  }

  .setting-main {
    margin-left: 20px;
    width: calc(100% - 240px);
    min-height: calc(100vh - 148px);
    // background: #fff;
    box-sizing: border-box;
    border-radius: $--border-radius-base;
    .main-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      padding: 20px;
      border-bottom: 1px solid #ddd;
      background: #fff;
      .header-title {
        font-size: 16px;
      }

      .edit-btn {
        color: #fff;
        background-color: $--color-primary;
      }
    }

    .setting-content {
      height: calc(100% - 71px);
      // padding: 20px;
    }
  }
}

.bottom-btns {
  display: flex;
  align-items: center;
  justify-content: center;

  position: fixed;
  bottom: 0;
  left: 0;

  width: 100%;
  height: 50px;

  background: #fff;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
  z-index: 100;

  .el-button {
    width: 120px;
  }
}
</style>